<template>
    <div class="fill-height d-flex flex-column flex-grow-1">
        <div class="d-flex justify-space-between">
            <h2 class="px-2">Urejanje škode št. {{ $route.params.id }}</h2>
        </div>

        <v-card class="skodenew pa-lg-4 pa-2 fill-height" :elevation="$vuetify.breakpoint.smAndUp > 0 ? 1 : 0">
            <v-btn to="/skode" fab color="white" exact top right absolute>
                <v-icon large color="red">mdi-close</v-icon>
            </v-btn>
            <div class="grid">
                <div class="left-part pl-4">
                    <v-form v-model="valid" ref="form">
                        <h3>Osnovni podatki</h3>
                        <v-row class="twocol">
                            <div>
                                <v-text-field
                                    v-model="formFields.Pogodba_ID"
                                    type="number"
                                    label="Pogodba ID"
                                    placeholder="Številka pogodbe"
                                    :rules="[(v) => !!(v > 99999 && v < 99999999999) || 'Dolžina mora biti med 6 in 11 znakov']"
                                    required
                                    counter="11"
                                    flat
                                    autofocus
                                    readonly
                                    @blur="refreshPogodbaData"
                                ></v-text-field>

                                <div v-if="auxPogodbaData.pogodba" class="ma-0">
                                    <v-expansion-panels class="hidden-lg-and-up mb-5">
                                        <v-expansion-panel>
                                            <v-expansion-panel-header>
                                                <h3>
                                                    Do zdaj obdelano škod:
                                                    {{ auxPogodbaData.skode.length }}
                                                </h3>
                                            </v-expansion-panel-header>
                                            <v-expansion-panel-content>
                                                <SkodePrejsnje :data="auxPogodbaData" />
                                            </v-expansion-panel-content>
                                        </v-expansion-panel>
                                    </v-expansion-panels>
                                </div>
                            </div>

                            <v-menu v-model="datumPicker" :close-on-content-click="false" max-width="290">
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        :value="formatiranDatum"
                                        append-icon="mdi-calendar"
                                        label="Datum"
                                        readonly
                                        v-on="on"
                                        @click:append="datumPicker = true"
                                        @click:clear="formatiranDatum = null"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="formFields.Datum"
                                    @change="datumPicker = false"
                                    :first-day-of-week="1"
                                    locale="sl-SI"
                                ></v-date-picker>
                            </v-menu>
                        </v-row>

                        <v-row class="twocol">
                            <v-autocomplete
                                v-model="formFields.Delavnica_ID"
                                :items="delavnice"
                                label="Delavnica"
                                placeholder="izberi delavnico"
                                no-data-text="Ni podatkov"
                                flat
                                required
                                item-value="ID"
                                item-text="Naziv"
                                :rules="[(v) => !!v || `Obvezen vnos`]"
                            ></v-autocomplete>
                            <v-text-field
                                v-model="formFields.Kontaktna_oseba"
                                type="text"
                                label="Kontaktna oseba"
                                placeholder="Ime in priimek"
                                flat
                            ></v-text-field>
                        </v-row>

                        <v-row class="twocol">
                            <v-text-field
                                v-model="formFields.Telefon"
                                type="tel"
                                label="Telefon"
                                prefix="+386"
                                placeholder="slovenska številka"
                                flat
                            ></v-text-field>
                        </v-row>

                        <v-row>
                            <v-textarea
                                rows="3"
                                label="Opis škode"
                                v-model="formFields.Opis_skode"
                                placeholder="Kratek tekst"
                                flat
                                auto-grow
                            ></v-textarea>
                        </v-row>

                        <v-row class="twocol">
                            <v-currency-field
                                v-model="formFields.Znesek_zahtevek"
                                label="Znesek zahtevka"
                                placeholder
                                required
                                flat
                                reverse
                                prefix="€"
                            />
                            <v-text-field
                                v-model="formFields.Aktualni_km"
                                type="number"
                                name="aktualni_km"
                                label="Aktualni kilometri"
                                placeholder
                                required
                                flat
                                reverse
                            ></v-text-field>
                        </v-row>

                        <v-row>
                            <v-textarea rows="3" label="Opomba za interno rabo" v-model="formFields.Opomba" placeholder flat></v-textarea>
                        </v-row>

                        <v-row>
                            <v-select
                                v-model="razlog_zavrnitve"
                                :items="razlogi_zavrnitve"
                                item-text="code"
                                item-value="code"
                                label="Razlog zavrnitve"
                                persistent-hint
                                return-object
                                single-line
                                v-on:change="set_opis_zavrnitve"
                            ></v-select>
                        </v-row>

                        <v-row>
                            <v-textarea rows="3" label="Opis zavrnitev" v-model="formFields.Opis_zavrnitev" placeholder flat></v-textarea>
                        </v-row>

                        <v-row class="twocol">
                            <v-currency-field
                                v-model="formFields.Nepriznano"
                                label="Znesek nepriznano / soudeležba"
                                placeholder
                                required
                                flat
                                reverse
                                prefix="€"
                            />
                        </v-row>

                        <v-row class="twocol">
                            <div>
                                <v-btn
                                    style="width: max-content"
                                    type="submit"
                                    color="primary"
                                    @click="save"
                                    :disabled="!valid"
                                    class="mt-5"
                                >
                                    Shrani
                                </v-btn>
                                <v-btn @click="odobri_skodo" class="mt-5 ml-2" style="width: max-content">Odobri</v-btn>
                                <v-btn @click="odobri_skodo" class="mt-5 ml-2" style="width: max-content">Zavrni</v-btn>
                            </div>
                            <div>
                                <div v-if="formFields.closed_at != null">
                                    Zaprto:
                                    <span v-html="humanDatum(formFields.closed_at)"></span>
                                </div>

                                <v-btn @click="zapri_skodo" :disabled="formFields.closed_at != null" class="mt-5" style="width: max-content"
                                    >Zapri škodo</v-btn
                                >

                                <v-btn
                                    @click="odpri_skodo"
                                    :disabled="formFields.closed_at === null"
                                    class="mt-5 ml-5"
                                    style="width: max-content"
                                    >Odpri škodo</v-btn
                                >
                            </div>
                        </v-row>
                    </v-form>
                </div>
                <v-divider vertical class="d-none d-lg-flex"></v-divider>

                <div class="right-part d-flex flex-row d-lg-flex flex-column">
                    <div v-if="auxPogodbaData.pogodba" class="hidden-md-and-down">
                        <h3 class="pb-5">Do zdaj obdelano škod: {{ auxPogodbaData.skode.length }}</h3>

                        <SkodePrejsnje :data="auxPogodbaData" :skoda_id="$route.params.id" />
                    </div>

                    <div class="mt-8">
                        <h2>Priloge</h2>
                        <v-form ref="upload">
                            <v-file-input
                                accept=".pdf, image/*"
                                show-size
                                required
                                label="Priloga"
                                name="fileToUpload"
                                v-model="formUpload.file"
                                placeholder="Izberite dokument v PDF ali JPG formatu"
                            ></v-file-input>
                        </v-form>

                        <v-btn type="submit" color="primary" @click="saveUpload" :disabled="!formUpload.file">Naloži prilogo</v-btn>
                    </div>

                    <div v-if="priloge.length > 0">
                        <div v-for="priloga in priloge" :key="priloga.ID" class="d-flex flex-row my-8">
                            <embed
                                v-if="priloga.Datoteka.indexOf('.pdf') > 0"
                                :src="`https://www.garancija-gsv.com/priloge/${priloga.Datoteka}`"
                                class="priloga"
                            />
                            <img v-else :src="`https://www.garancija-gsv.com/priloge/${priloga.Datoteka}`" class="priloga" />
                            <v-btn class="red--text pl-4 align-self-start" :title="priloga.ID" text @click="deletePriloge(priloga.ID)">
                                <h2>🗙</h2>
                            </v-btn>
                        </div>
                    </div>

                    <div v-if="prilogeBrisane.length > 0">
                        <h4>Brisane priloge</h4>
                        <div v-for="priloga in prilogeBrisane" :key="priloga.ID">
                            <div class="d-flex flex-row my-4 align-center">
                                <v-btn class="blue--text mr-4" @click="undeletePriloge(priloga.ID)" text outlined>Povrni</v-btn>
                                {{ priloga.Datoteka }}, brisana
                                <span v-html="humanDatum(priloga.deleted_at)" class="ml-1"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </v-card>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import SkodePrejsnje from "./SkodePrejsnje";
import VCurrencyField from "@/modules/VCurrencyField";

const emptySkodeFormFields = {
    Pogodba_ID: "",
    Datum: new Date().toISOString().substr(0, 10),
    Delavnica_ID: null,
    Kontaktna_oseba: "",
    Telefon: "",
    Opis_skode: "",
    Znesek_zahtevek: 0.0,
    Aktualni_km: 0,
    Opomba: "",
    Status: "P",
    Nepriznano: 0,
    closed_at: null,
};

myVars.currentSkodeFormFields = Object.assign({}, emptySkodeFormFields); // this serves as cache for partially entered forms

export default {
    props: ["ID"],

    components: {
        SkodePrejsnje,
        VCurrencyField,
    },

    data: () => ({
        valid: false,
        datumPicker: false,
        formFields: myVars.currentSkodeFormFields,
        formUpload: {
            file: null,
        },
        auxPogodbaData: {
            pogodba: null,
            skode: [],
            errorNotExists: false,
            produkt: null,
        },
        priloge: [],
        prilogeBrisane: [],
        dn: null,
        razlog_zavrnitve: {},
        razlogi_zavrnitve: [
            { code: "2. člen", content: "Po 2. členu pogojev." },
            {
                code: "2. člen - servis",
                content: "Po 2. členu pogojev.\nServis mora biti opravljen v skladu z določili pogojev, ki so sestavni del vaše pogodbe.",
            },

            { code: "3. člen", content: "Po 3. členu pogojev." },
            {
                code: "3. člen – napaka po pogodbi ni krita",
                content:
                    "Pogodba o izvajanju storitev zajema samo tiste napake in pripadajoče delo, ki so v pogojih, ki so sestavni del vaše pogodbe navedeni.",
            },

            { code: "5. člen", content: "Po 5. členu pogojev." },

            {
                code: "5. člen – rok za prijavo",
                content: "Po 5. členu pogojev.\nNapaka ni bila javljena v roku 5 dni po njenem nastanku.",
            },
            {
                code: "5. člen – servisna delavnica",
                content:
                    "Po 5. členu pogojev.\nGSV ne odgovarja za posege na vozilu, ki niso opravljeni v mehanični delavnici GSV in iz tega naslova ne povrne nikakršnih stroškov.",
            },

            {
                code: "6. člen – garancija, stvarna napaka",
                content: "Po 6. členu pogojev.",
            },
        ],
    }),

    mounted() {
        // console.log("skode edit mounted");
    },

    async created() {
        // console.log("skode edit created");

        let that = this;
        await this.$axios
            .get(`/skode/${this.$route.params.id}`)
            .then(function(response) {
                // console.log(response.data);
                let record = response.data;
                Object.keys(that.formFields).forEach((field) => {
                    that.formFields[field] = record[field];
                });
            })
            .catch(function(error) {
                let errorMessage = alert(that.$route.name + "\n" + window.location + "\n\n" + error.response.data + "\n\n" + error);
            });

        // naloži se delovni nalog k tej skodi, ki je ena za ena
        await this.$axios.get(`/dn_za_skodo/${this.$route.params.id}`).then(function(response) {
            console.log("DN:", response.data);
            that.dn = response.data;
            that.formFields.Nepriznano = that.dn.Nepriznano;
        });

        this.refreshPogodbaData();
    },
    computed: {
        ...mapGetters(["user", "loggedIn"]),

        delavnice: (e) => e.$root.$data.delavnice.selectItems,

        formatiranDatum: {
            get() {
                return this.datum(this.formFields.Datum);
                // const d = new Date(Date.parse(this.formFields.Datum));
                // return d.toLocaleDateString("sl-SI");
            },
            set(valueFromPicker) {
                this.formFields.Datum = valueFromPicker;
            },
        },
    },
    methods: {
        set_opis_zavrnitve(val) {
            this.formFields.Opis_zavrnitev = val.content;
        },

        save(e) {
            e.preventDefault();
            this.$refs.form.validate();
            if (this.valid) {
                const that = this;
                const saveFormFields = Object.assign({}, that.formFields);

                const dnFormFields = { Nepriznano: saveFormFields.Nepriznano };
                delete saveFormFields.Nepriznano;

                myVars.currentSkodeFormFields = Object.assign({}, emptySkodeFormFields);

                this.$axios
                    .patch(`/skode/${this.$route.params.id}`, saveFormFields)
                    .then(function(response) {
                        that.$axios
                            .patch(`/dn/${that.dn.ID}`, dnFormFields)
                            .then(function(response) {
                                that.$router.replace("/skode/");
                            })
                            .catch(function(error) {
                                console.log(error);
                            });

                        // // console.log("saved", saveFormFields);
                    })
                    .catch(function(error) {
                        // console.log(error);
                    });

                // nepriznano se shrani v delovni nalgo, ne v skodo ... relic
            } else {
                console.error(this.form);
            }
        },

        odobri_skodo(e) {
            e.preventDefault();
            const saveFormFields = { Odobril_operater: "avaupotic", Odobritev_datum: new Date().toISOString(), Status: "O" };
            const that = this;

            this.$axios
                .patch(`/skode/odobri/${this.$route.params.id}`, saveFormFields)
                .then(function(response) {
                    console.log("saved zapri");
                    that.$router.replace("/skode/");
                })
                .catch(function(error) {
                    console.log(error);
                });
        },

        zapri_skodo(e) {
            e.preventDefault();
            const saveFormFields = { closed_at: new Date().toISOString() };
            const that = this;

            this.$axios
                .patch(`/skode/close/${this.$route.params.id}`, saveFormFields)
                .then(function(response) {
                    console.log("saved zapri");
                    that.$router.replace("/skode/");
                })
                .catch(function(error) {
                    console.log(error);
                });
        },

        odpri_skodo(e) {
            e.preventDefault();
            const saveFormFields = { closed_at: null };
            const that = this;

            this.$axios
                .patch(`/skode/open/${this.$route.params.id}`, saveFormFields)
                .then(function(response) {
                    console.log("saved open");
                    that.$router.replace("/skode/");
                })
                .catch(function(error) {
                    console.log(error);
                });
        },

        saveUpload(e) {
            e.preventDefault();
            let that = this;
            // console.log(this.formUpload.file);
            let fd = new FormData();
            fd.append("priloga", this.formUpload.file, this.formUpload.file.name);
            fd.append("Dodal_operater", this.user.data.handle);
            console.log(this.user.data.handle);

            this.$axios
                .post(`/priloge/${this.$route.params.id}`, fd)
                .then((resp) => {
                    // console.log("posted!");
                    that.formUpload.file = "";
                    var url = `/priloge/${that.$route.params.id}`;
                    that.$axios.get(url).then((response) => (that.priloge = eval(response.data)));
                })
                .catch(function(error) {
                    // console.log(error);
                });

            //
        },

        deletePriloge(priloga_id) {
            let that = this;
            this.$axios
                .delete(`/priloge/${priloga_id}`)
                .then(async (resp) => {
                    // console.log("deleted!");

                    var url = `/priloge/${that.$route.params.id}`;
                    await that.$axios.get(url).then((response) => (that.priloge = eval(response.data)));

                    var url = `/priloge/${this.$route.params.id}/deleted`;
                    await this.$axios.get(url).then((response) => (that.prilogeBrisane = eval(response.data)));
                })
                .catch(function(error) {
                    // console.log(error);
                });
        },

        undeletePriloge(priloga_id) {
            let that = this;
            this.$axios
                .patch(`/priloge/${priloga_id}/undelete`)
                .then(async (resp) => {
                    // console.log("undeleted!");

                    var url = `/priloge/${that.$route.params.id}`;
                    await that.$axios.get(url).then((response) => (that.priloge = eval(response.data)));

                    var url = `/priloge/${this.$route.params.id}/deleted`;
                    await this.$axios.get(url).then((response) => (that.prilogeBrisane = eval(response.data)));
                })
                .catch(function(error) {
                    // console.log(error);
                });
        },

        async refreshPogodbaData() {
            let that = this;
            var url = `/v_pogodbe/${this.formFields.Pogodba_ID}`;
            await this.$axios.get(url).then((response) => (that.auxPogodbaData.pogodba = eval(response.data)));

            console.log(this.auxPogodbaData.pogodba);

            this.auxPogodbaData.errorNotExists = !this.auxPogodbaData.pogodba;

            var url = `/produkti/${this.auxPogodbaData.pogodba.Produkt_ID}`;
            await this.$axios.get(url).then((response) => (that.auxPogodbaData.produkt = eval(response.data)));

            var url = `/v_skode_full_by_vin/${this.auxPogodbaData.pogodba.Sasija}`;
            await this.$axios
                .get(url)
                .then((response) => (that.auxPogodbaData.skode = eval(response.data)))
                .catch((error) => false);

            var url = `/priloge/${this.$route.params.id}`;
            await this.$axios.get(url).then((response) => (that.priloge = eval(response.data)));

            var url = `/priloge/${this.$route.params.id}/deleted`;
            await this.$axios.get(url).then((response) => (that.prilogeBrisane = eval(response.data)));
        },
    },
};
</script>

<style scoped lang="scss">
.grid {
    display: grid;
    grid-template-columns: 1fr;
    column-gap: 3rem;
}

.twocol {
    display: grid;
    grid-template-columns: 1fr;
}

@media #{map-get($display-breakpoints, 'lg-and-up')} {
    .grid {
        grid-template-columns: 5fr 1px 8fr;
    }

    .twocol {
        grid-template-columns: 1fr;
        grid-gap: 2rem;
    }
}

@media #{map-get($display-breakpoints, 'xl-only')} {
    .grid {
        grid-template-columns: 5fr 1px 8fr;
    }

    .twocol {
        grid-template-columns: 1fr 1fr;
        grid-gap: 2rem;
    }
}

.v-expansion-panel::before {
    box-shadow: none;
}

.v-expansion-panel-content__wrap {
    padding: 0 !important;
}

.left-part > * {
    margin: 0;
}

embed.priloga {
    width: 640px;
    height: 950px;
}

img.priloga {
    object-fit: contain;
    object-position: 0 0;
    max-width: 640px;
    width: 100%;
}

@media #{map-get($display-breakpoints, 'xl-only')} {
    embed.priloga {
        width: 800px;
        height: 1200px;
    }

    img.priloga {
        object-fit: contain;
        object-position: 0 0;
        max-width: 800px;
        width: 100%;
    }
}
</style>
